import { CoordinatePoint, CoordinatePointModel } from './coordinate-point';

export interface AirSpaceBoundaryCoordinatePoint {
    id:number,
    altitude:number,
    coordPoint:CoordinatePointModel,
    airspaceboundaryCoordPointPk: number,
    airspaceboundaryPk: number,
    sequencenumber:number,

}

export class AirSpaceBoundaryCoordinatePointModel implements AirSpaceBoundaryCoordinatePoint {
  id:number;
  altitude:number;
  coordPoint:CoordinatePointModel;
  airspaceboundaryCoordPointPk: number;
  airspaceboundaryPk: number;
  sequencenumber:number;
}
